import { Box } from '@mui/material';

const UtilityDrawerFooter = ({ children }) => (
  <Box p={[2, 3]} data-testid="UtilityDrawer.Footer">
    {children}
  </Box>
);

export default UtilityDrawerFooter;
